import { HttpClient } from "@angular/common/http";
import { Inject, Injectable } from "@angular/core";
import { TableService } from "src/app/_metronic/shared/crud-table";

@Injectable({
  providedIn: "root",
})
export class ChatService extends TableService<any> {
  constructor(@Inject(HttpClient) http) {
    super(http);
  }
  N8N_URL = "https://n8n.datlaz.com/webhook/chat-help-bot";

  sendMessage(message, userSid) {
    const payload = {
      text: message,
      sid: userSid,
    };
    return this.http.post(this.N8N_URL, payload);
  }
}
